module.exports = __webpack_public_path__ + "media/images/redesign-images/home/single-flat-lay-placeholder-9a8ab94e0cfb1eae209c684efd1a6d3f.png";